import { Injectable } from '@angular/core';
import { FormValuesService } from '../form-values/form-values.service';
import { Router } from '@angular/router';
import { Subject } from 'rxjs/Subject';
import { ApiService } from '../api/api.service';
import { Customer } from '../../customer-overview/customer-overview.component';

interface ILib {
  alpha: string[],
  number: string[],
  symbols: string[]
}

type Key = keyof ILib;

@Injectable()
export class CustomerEditService {
  
  private _updateForm = new Subject();
  updateForm$ = this._updateForm.asObservable();

  private customerFormdata;
  
  private customers = [];
  /*
  private customers = [
    {
      id: "4b436cb297bf067823ba6b604107be11",
      firstName: "Allison",
      lastName: "Mustermann",
      panel: false,
      date: "Thu Mar 22 2018 11:01:51 GMT+0100 (CET)",
      avatar: "http://lorempixel.com/46/46/people/",
      streetName: "Maxmuellerstraße",
      streetNum: "42",
      zip: "81247",
      city: "München",
      email: "test.petermann@internet.com",
      phone: "0894124151247",
      cell: "0123456789",
      geburtsdatum: "01.01.2009",
      familyStat: "verheiratet",
      spouseFirstName: "Frauke",
      spouseLastName: "Petermann",
      kids: [
        {
          name: "Maximilian Petermann",
          age: "18"
        },
        {
          name: "Hans Petermann",
          age: "12"
        },
        {
          name: "Isabell Petermann",
          age: "8"
        },
        {
          name: "Maximilian Petermann",
          age: "18"
        },
        {
          name: "Hans Petermann",
          age: "12"
        },
        {
          name: "Isabell Petermann",
          age: "8"
        },
        {
          name: "Maximilian Petermann",
          age: "18"
        },
        {
          name: "Hans Petermann",
          age: "12"
        },
        {
          name: "Isabell Petermann",
          age: "8"
        },
      ]
    },
  ]
  */
  
  private newCustomer = {
    id: this.generateId(10),
    salutation: "",
    firstName: "",
    lastName: "",
    panel: false,
    date: "Thu Mar 22 2018 11:01:51 GMT+0100 (CET)",
    avatar: "http://lorempixel.com/46/46/people/",
    state: "",
    street: "",
    zip: "",
    city: "",
    email: "",
    phone: "",
    cell: "",
    geburtsdatum: "",
    familyStat: "1",
    kids: [],
    contracts: [],
    work: "",
    spouse: {
      id: this.generateId(10),
      salutation: "",
      firstName: "",
      lastName: "",
      panel: false,
      date: "Thu Mar 22 2018 11:01:51 GMT+0100 (CET)",
      avatar: "http://lorempixel.com/46/46/people/",
      state: "",
      street: "",
      zip: "",
      city: "",
      email: "",
      phone: "",
      cell: "",
      geburtsdatum: "",
      familyStat: "1",
      work: ""
    },
  };

  private currentIndex;

  constructor(
    private formValueService: FormValuesService, 
    private router: Router,
    private apiService: ApiService
  ) { }
  
  public getCustomerShortList(){
    let obs = this.apiService.getCustomerShortList();
    this.customers= [];    
    obs.subscribe( (data:any) => {
      data.result[0].DatensaetzeShortList.forEach( (customer: Customer) => {
        customer.panel = false;
        customer.date  = new Date().toDateString();
        this.customers.push(customer);  
      });
    });
    
    return this.customers;
  }

  /*
  public getCustomerIds(){
    return this.apiService.getCustomerShortList();
    
    We got a better way to get this data for now
    return this.apiService.getCustomerIds()
    .then((ids:any)=>{
      let promises : Array<Promise<any>> = [];
      ids.result[0].datensatzIds.forEach(id => {
        promises.push( this.getCustomer(id.datensatzId) );
      });
      
      Promise.all(promises).then(customers=>{
        this.customers = customers; 
      })
      
      return Promise.all( promises );
    })
    
  }
  
  public getCustomer(id) : Promise<any> {
    let obj = { "datensatzId": ""};
    obj.datensatzId = id;
    return this.apiService.getCustomerDetails(obj)
    .then( (response : any) => {
      let person1               = response.result[0].personenIntro[0];
      let customer              = Object.assign({}, this.newCustomer);
      customer.kids             = [];
      customer.contracts        = [];
      customer.id               = person1.personenId;
      customer.firstName        = person1.vorname;
      customer.lastName         = person1.nachname;
      customer.street           = person1.strasse_nr;
      customer.zip              = person1.plz;
      customer.city             = person1.ort;
      customer.email            = person1.email;
      customer.phone            = person1.telefon;
      customer.cell             = person1.telefonMobil;
      customer.geburtsdatum     = person1.geburtsdatum;
      customer.familyStat       = response.result[0].beziehungsstatus;
      customer.contracts        = response.result[0].vertragsIntro;
      
      if(response.result[0].personenIntro[1]){
        let person2 = response.result[0].personenIntro[1];  
        customer.spouse.firstName = person2.vorname;
        customer.spouse.lastName  = person2.nachname;
      }
      
      if(response.result[0].kinderIntro.length){
        let kids = response.result[0].kinderIntro;
        kids.forEach(kid => {
          customer.kids.push( { name: kid.vorname , age: kid.geburtsdatum } );
        });
      }
      
      return customer;
    }, ( error ) => {
      console.log(error);
    });
  }
  
  public getCustomers() {    
    this.customers = JSON.parse(this.formValueService.getValue('customers'));
    return this.customers
  }
  
  */

  public getCustomerFormdata(id,copy) {

    let currentCustomer;

    if (id === "neuer Kunde") {
      currentCustomer = Object.assign({}, this.newCustomer);
      if ( !this.customers ){
        this.customers = [];
      } 
      this.customers.push(currentCustomer);
      this.currentIndex = this.customers.length - 1;
    } else if (copy === 'true') {
      this.customers.forEach((customer, index) => {
        if (id === customer.id) {
          currentCustomer     = Object.assign({}, customer);
          currentCustomer.id  = this.generateId(10);
          this.customers.push(currentCustomer);
          this.currentIndex   = this.customers.length - 1;
        }
      });
    } else {
      this.customers.forEach((customer, index) => {
        if (id === customer.id) {
          currentCustomer = customer;
          this.currentIndex = index;
        }
      });
    }

    this.customerFormdata = [];
    this.customerFormdata = [
      {
        "uiType": "page",
        "id": 1,
        "displayText": "Kundenübersicht",
        "items": [
          {
            "jsonName": "salutation",
            "displayText": "Anrede",
            "uiType": "selectfield",
            "requestType": "integer",
            "selectValues": [
              "Frau",
              "Herr",
            ],
            "selectValuesDisplayText": [
              "Frau",
              "Herr",
            ],
            "optional": false,
            "sampleValue": currentCustomer.salutation + ''
          },
          { "jsonName": "firstName", "displayText": "Vorname", "uiType": "text", "requestType": "string", "optional": false, "sampleValue": currentCustomer.firstName + '' },
          { "jsonName": "lastName", "displayText": "Nachname", "uiType": "text", "requestType": "string", "optional": false, "sampleValue": currentCustomer.lastName + '' },
          { "jsonName": "geburtsdatum", "displayText": "Geburtsdatum", "uiType": "text", "requestType": "string", "optional": false, "sampleValue": currentCustomer.geburtsdatum + '' },
          {
            "jsonName": "familyStat",
            "displayText": "Familienstatus",
            "uiType": "selectfield",
            "requestType": "integer",
            "selectValues": [
              "1",
              "2",
              "3",
              "4",
              "5",
              "6",
              "7",
              "8",
              "9",
              "10",
            ],
            "selectValuesDisplayText": [
              "ledig",
              "verheiratet",
              "verwitwet",
              "geschieden",
              "Ehe aufgehoben",
              "in eingetragener Lebenspartnerschaft",
              "durch Tod aufgelöste Lebenspartnerschaft",
              "aufgehobene Lebenspartnerschaft",
              "durch Todeserklärung aufgelöste Lebenspartnerschaft",
              "nicht bekannt"
            ],
            "optional": true,
            "sampleValue": currentCustomer.familyStat + '' 
          },
          {
            "jsonName": "berufsgruppe",
            "displayText": "Berufsgruppe",
            "uiType": "selectfield",
            "requestType": "integer",
            "selectValues": [
              "1",
              "2",
              "3",
              "4",
              "5",
              "6",
              "7",
              "8"
            ],
            "selectValuesDisplayText": [
              "Arbeitnehmer(in)",
              "Arbeitnehmer(in) im \u00F6D",
              "Beamter(-in)",
              "Selbst\u00E4ndige(r)",
              "Arbeitslose(r)",
              "Hausfrau \/-mann",
              "Sch\u00FCler(in) \/ Student(in)",
              "Rentner(in)"
            ],
            "optional": false,
            "sampleValue": currentCustomer.work + '' 
          },
          { "jsonName": "street", "displayText": "Straße", "uiType": "text", "requestType": "string", "optional": false, "sampleValue": currentCustomer.street + '' },
          { "jsonName": "zip", "displayText": "Postleitzahl", "uiType": "integer", "requestType": "integer", "optional": false, "sampleValue": currentCustomer.zip + '' },
          { "jsonName": "city", "displayText": "Ort", "uiType": "text", "requestType": "string", "optional": false, "sampleValue": currentCustomer.city + '' },
          {
            "jsonName": "bundesland",
            "displayText": "Bundesland",
            "uiType": "selectfield",
            "requestType": "string",
            "selectValues":
              [
                "Baden-Württemberg",
                "Bayern",
                "Berlin",
                "Brandenburg",
                "Bremen",
                "Hamburg",
                "Hessen",
                "Mecklenburg-Vorpommern",
                "Niedersachsen",
                "Nordrhein-Westfalen",
                "Rheinland-Pfalz",
                "Saarland",
                "Sachsen",
                "Sachsen-Anhalt",
                "Schleswig-Holstein",
                "Thüringen"
              ]
            ,
            "selectValuesDisplayText":
              [
                "Baden-Württemberg",
                "Bayern",
                "Berlin",
                "Brandenburg",
                "Bremen",
                "Hamburg",
                "Hessen",
                "Mecklenburg-Vorpommern",
                "Niedersachsen",
                "Nordrhein-Westfalen",
                "Rheinland-Pfalz",
                "Saarland",
                "Sachsen",
                "Sachsen-Anhalt",
                "Schleswig-Holstein",
                "Thüringen"
              ]
            ,
            "optional": false,
            "sampleValue": currentCustomer.state + ''
          },
          { "jsonName": "email", "displayText": "Email", "uiType": "text", "requestType": "string", "optional": false, "sampleValue": currentCustomer.email + '' },
          { "jsonName": "phone", "displayText": "Telefon", "uiType": "integer", "requestType": "integer", "optional": false, "sampleValue": currentCustomer.phone + '' },
          { "jsonName": "cell", "displayText": "Tel mobil", "uiType": "integer", "requestType": "integer", "optional": false, "sampleValue": currentCustomer.cell + '' },
          {
            "jsonName": "salutationSpouse",
            "displayText": "Anrede",
            "uiType": "selectfield",
            "requestType": "integer",
            "selectValues": [
              "Frau",
              "Herr",
            ],
            "selectValuesDisplayText": [
              "Frau",
              "Herr",
            ],
            "optional": false,
            "sampleValue": currentCustomer.spouse.salutation + '',
            "divider":"line"
          },
          { "jsonName": "firstNameSpouse", "displayText": "Vorname", "uiType": "text", "requestType": "string", "optional": false, "sampleValue": currentCustomer.spouse.firstName + '' },
          { "jsonName": "lastNameSpouse", "displayText": "Nachname", "uiType": "text", "requestType": "string", "optional": false, "sampleValue": currentCustomer.spouse.lastName + '' },
          { "jsonName": "geburtsdatumSpouse", "displayText": "Geburtsdatum", "uiType": "text", "requestType": "string", "optional": false, "sampleValue": currentCustomer.spouse.geburtsdatum + '' },
          {
            "jsonName": "familyStatSpouse",
            "displayText": "Familienstatus",
            "uiType": "selectfield",
            "requestType": "integer",
            "selectValues": [
              "1",
              "2",
              "3",
              "4",
              "5",
              "6",
              "7",
              "8",
              "9",
              "10",
            ],
            "selectValuesDisplayText": [
              "ledig",
              "verheiratet",
              "verwitwet",
              "geschieden",
              "Ehe aufgehoben",
              "in eingetragener Lebenspartnerschaft",
              "durch Tod aufgelöste Lebenspartnerschaft",
              "aufgehobene Lebenspartnerschaft",
              "durch Todeserklärung aufgelöste Lebenspartnerschaft",
              "nicht bekannt"
            ],
            "optional": true,
            "sampleValue": currentCustomer.spouse.familyStat + '',
          },
          {
            "jsonName": "berufsgruppeSpouse",
            "displayText": "Berufsgruppe",
            "uiType": "selectfield",
            "requestType": "integer",
            "selectValues": [
              "1",
              "2",
              "3",
              "4",
              "5",
              "6",
              "7",
              "8"
            ],
            "selectValuesDisplayText": [
              "Arbeitnehmer(in)",
              "Arbeitnehmer(in) im \u00F6D",
              "Beamter(-in)",
              "Selbst\u00E4ndige(r)",
              "Arbeitslose(r)",
              "Hausfrau \/-mann",
              "Sch\u00FCler(in) \/ Student(in)",
              "Rentner(in)"
            ],
            "optional": false,
            "sampleValue": currentCustomer.spouse.work + '',
          },
          { "jsonName": "streetSpouse", "displayText": "Straße", "uiType": "text", "requestType": "string", "optional": false, "sampleValue": currentCustomer.spouse.street + '' },
          { "jsonName": "zipSpouse", "displayText": "Postleitzahl", "uiType": "integer", "requestType": "integer", "optional": false, "sampleValue": currentCustomer.spouse.zip + '' },
          { "jsonName": "citySpouse", "displayText": "Ort", "uiType": "text", "requestType": "string", "optional": false, "sampleValue": currentCustomer.spouse.city + '' },
          {
            "jsonName": "bundeslandSpouse",
            "displayText": "Bundesland",
            "uiType": "selectfield",
            "requestType": "string",
            "selectValues":
              [
                "Baden-Württemberg",
                "Bayern",
                "Berlin",
                "Brandenburg",
                "Bremen",
                "Hamburg",
                "Hessen",
                "Mecklenburg-Vorpommern",
                "Niedersachsen",
                "Nordrhein-Westfalen",
                "Rheinland-Pfalz",
                "Saarland",
                "Sachsen",
                "Sachsen-Anhalt",
                "Schleswig-Holstein",
                "Thüringen"
              ]
            ,
            "selectValuesDisplayText":
              [
                "Baden-Württemberg",
                "Bayern",
                "Berlin",
                "Brandenburg",
                "Bremen",
                "Hamburg",
                "Hessen",
                "Mecklenburg-Vorpommern",
                "Niedersachsen",
                "Nordrhein-Westfalen",
                "Rheinland-Pfalz",
                "Saarland",
                "Sachsen",
                "Sachsen-Anhalt",
                "Schleswig-Holstein",
                "Thüringen"
              ]
            ,
            "optional": false,
            "sampleValue": currentCustomer.spouse.state + ''
          },
          { "jsonName": "emailSpouse", "displayText": "Email", "uiType": "text", "requestType": "string", "optional": false, "sampleValue": currentCustomer.spouse.email + '' },
          { "jsonName": "phoneSpouse", "displayText": "Telefon", "uiType": "integer", "requestType": "integer", "optional": false, "sampleValue": currentCustomer.spouse.phone + '' },
          { "jsonName": "cellSpouse", "displayText": "Tel mobil", "uiType": "integer", "requestType": "integer", "optional": false, "sampleValue": currentCustomer.spouse.cell + '' },
          { "jsonName": "addKid", "displayText": "Haben Sie Kinder?", "uiType": "button", "requestType": "string", "optional": false, "sampleValue": "button"}
        ]
      }
    ];    
    
    currentCustomer.kids.forEach( (kid,index) => {
      this.customerFormdata[0].items = this.addKidCustomerFormData(this.customerFormdata[0].items, kid, index);  
    });    
    return this.customerFormdata;
  }
  
  public addKidCustomerFormData (items, kid?, index?) {    
    
    let currentKid = {
      firstName: "",
      lastName: "",
      age:  "01.01.1990"
    };  
    
    let currentIndex : number;
    
    if( kid && index  != undefined ){
      currentKid.firstName  = kid.firstName;
      currentKid.lastName   = kid.lastName;
      currentKid.age        = kid.age;
      currentIndex          = index;
    } else {
      this.customers[this.currentIndex].kids.push(currentKid);
      currentIndex = this.customers[this.currentIndex].kids.length - 1;
    }
    
    for(let i = 0; i < 4; i++){
      items.push(items[items.length-1]);  
    }
    
    items[items.length-5] = { "jsonName": "geschlecht"   + "Kid" + currentIndex, "displayText": `Geschlecht Kind    ${currentIndex + 1}`, "uiType": "selectfield", "requestType":"integer", "selectValues":["1","2"],"selectValuesDisplayText":["m\u00E4nnlich","weiblich"],"optional":true,"sampleValue":"1", "divider":"line"},
    items[items.length-4] = { "jsonName": "firstName"    + "Kid" + currentIndex, "displayText": `Vorname Kind       ${currentIndex + 1}`, "uiType": "text", "requestType": "string", "optional": false, "sampleValue": currentKid.firstName };
    items[items.length-3] = { "jsonName": "lastName"     + "Kid" + currentIndex, "displayText": `Nachname Kind      ${currentIndex + 1}`, "uiType": "text", "requestType": "string", "optional": false, "sampleValue": currentKid.lastName };
    items[items.length-2] = { "jsonName": "geburtsdatum" + "Kid" + currentIndex, "displayText": `Geburtsdatum Kind  ${currentIndex + 1}`, "uiType": "text", "requestType": "string", "optional": false, "sampleValue": currentKid.age };

    return items;
  }
  
  public dissolveBirth(date){
    try {
      if (date.day.toString().length == 1) {
        date.day = "0" + date.day;
      }
      if (date.month.toString().length == 1) {
        date.month = "0" + date.month;
      }
      return date.day + "." + date.month + "." + date.year;
    } catch (error) {
      return date
    }
  }
  
  public dissolveCustomerFormdata(questions) {
    
    this.dissolver(questions);
    
    this.updateCustomers();

    this.router.navigate(['/kundenuebersicht']);
  }
  
  public dissolver(questions){    
    for (let question in questions) {
      if (questions[question].key === 'geburtsdatum') {
        if( questions[question].controlAssociated ){
          this.customers[this.currentIndex][questions[question].key] = this.dissolveBirth(questions[question].controlAssociated.value);  
        } else {
          this.customers[this.currentIndex][questions[question].key] = this.dissolveBirth(questions[question].standardValue);  
        }        
      } else if ( questions[question].key.substring(0,15) === 'geburtsdatumKid' ){ 
        if( questions[question].controlAssociated ){
          this.customers[this.currentIndex].kids[parseInt(questions[question].key.substring(15))].age = this.dissolveBirth(questions[question].controlAssociated.value);
        } else {
          this.customers[this.currentIndex].kids[parseInt(questions[question].key.substring(15))].age = this.dissolveBirth(questions[question].standardValue);
        }
      } else if ( questions[question].key.substring(0,12) === 'firstNameKid'){   
        if( questions[question].controlAssociated ){
          this.customers[this.currentIndex].kids[parseInt(questions[question].key.substring(12))].firstName = questions[question].controlAssociated.value;
        } else {
          this.customers[this.currentIndex].kids[parseInt(questions[question].key.substring(12))].firstName = questions[question].standardValue;
        }
      } else if ( questions[question].key.substring(0,11) === 'lastNameKid' ){   
        if( questions[question].controlAssociated ){
          this.customers[this.currentIndex].kids[parseInt(questions[question].key.substring(11))].lastName = questions[question].controlAssociated.value;
        } else {
          this.customers[this.currentIndex].kids[parseInt(questions[question].key.substring(11))].lastName = questions[question].standardValue;
        }
      } else if ( questions[question].key.substring(0,10) === 'familyStat' ){ 
        if( questions[question].controlAssociated ){
          this.customers[this.currentIndex][questions[question].key] = questions[question].options[parseInt(questions[question].controlAssociated.value)-1].label;
        } else {
          this.customers[this.currentIndex][questions[question].key] = questions[question].options[parseInt(questions[question].standardValue)-1].label;
        }
      } else {
        if( questions[question].controlAssociated ){
          this.customers[this.currentIndex][questions[question].key] = questions[question].controlAssociated.value;  
        } else {
          this.customers[this.currentIndex][questions[question].key] = questions[question].standardValue; 
        }        
      }
    }
  }
  
  public changeAvatar( img,index ) {
    this.customers[index].avatar = img;
    this.updateCustomers(); 
  }
  
  public deleteCustomer(index){
    this.customers.splice(index, 1);
    this.updateCustomers(); 
  }
  
  private updateCustomers(){
    this.formValueService.setValue('customers', JSON.stringify(this.customers));
  }

  private generateId(index: number, customKeys?: Key[]): string {
    const lib: ILib = {
      alpha: [
        'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n',
        'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z',
        'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N',
        'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z',
      ],
      number: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'],
      symbols: ['_', '-', '$', '!', '%', '?']
    };

    const defaultKeys: Key[] = ['alpha', 'number', 'symbols'];

    const keys: string[] = customKeys
      || defaultKeys;
    const customLib: string[] = keys
      .map((a: Key) => lib[a])
      .reduce((a, b) => a.concat(b));
    const n: number = customLib.length;

    let generatedId: string[] = [];

    while (index > 0) {
      generatedId.push(customLib[Math.round(Math.random() * n)]);
      index -= 1;
    }

    return generatedId.join('');
  }
  
  public updateForm(todo){
    this._updateForm.next(todo);
  }

}


// WEBPACK FOOTER //
// ./src/app/services/customer-edit/customer-edit.service.ts